import React, { useState, useEffect } from 'react';
import { Cookie, X } from '@phosphor-icons/react';

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem('cookie_consent');
    if (!accepted) setVisible(true);
  }, []);

  const accept = () => {
    localStorage.setItem('cookie_consent', 'accepted');
    setVisible(false);
  };

  const decline = () => {
    localStorage.setItem('cookie_consent', 'declined');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 sm:p-6" data-testid="cookie-consent-banner">
      <div className="max-w-3xl mx-auto bg-white border border-[#E5E3DB] rounded-2xl shadow-xl p-5 sm:p-6 flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <div className="flex items-start gap-3 flex-1">
          <div className="w-10 h-10 rounded-full bg-[#F2EFE9] flex items-center justify-center flex-shrink-0 mt-0.5">
            <Cookie size={20} weight="duotone" className="text-[#5C6B62]" />
          </div>
          <div>
            <p className="text-sm font-medium text-[#1E2922] mb-1">We value your privacy</p>
            <p className="text-xs text-[#5C6B62] leading-relaxed">
              We use essential cookies to keep the app working and secure. No tracking or marketing cookies are used.
              By continuing, you agree to our use of necessary cookies for authentication and functionality.
            </p>
          </div>
        </div>
        <div className="flex items-center gap-2 flex-shrink-0 w-full sm:w-auto">
          <button onClick={decline} data-testid="cookie-decline-btn"
            className="flex-1 sm:flex-none text-sm px-4 py-2 rounded-lg border border-[#E5E3DB] text-[#5C6B62] hover:bg-[#F2EFE9] transition-all font-medium">
            Decline
          </button>
          <button onClick={accept} data-testid="cookie-accept-btn"
            className="flex-1 sm:flex-none text-sm px-5 py-2 rounded-lg bg-[#2C4A3B] text-white hover:bg-[#3A5C4A] transition-all font-medium">
            Accept
          </button>
        </div>
      </div>
    </div>
  );
}
